module.exports = __webpack_public_path__ + "img/icon_asset_mgmt_blue.f17d4101.svg";